<template>
  <footer class="app-footer">
    <div class="footer-divider"></div>
    <div class="footer-content">
      <p>&copy; {{ year }} {{ content.name }}</p>
      <div class="footer-right">
        <span>Version {{ content.appVersion }}</span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { content } from "@/content/data";

const year = new Date().getFullYear();
</script>
